import { FC, SVGProps } from "react";

const AddIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round"  {...props}>
      <line x1="10" y1="3" x2="10" y2="17"/>
      <line x1="3" y1="10" x2="17" y2="10"/>
    </svg>
  );
};

export default AddIcon;
